import { render, staticRenderFns } from "./CartSave.vue?vue&type=template&id=2e35f55c"
import script from "./CartSave.vue?vue&type=script&lang=js"
export * from "./CartSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports